<template>
  <div class="help-feedback">
    <!-- <header-custom :title="$t('profile.personalCenter.help')" @left-click="handleBack"></header-custom> -->
    <div class="common-issue">
      {{ $t('profile.help.commonIssue') }}
    </div>
    <template v-for="(issue, index) in issues">
      <line-text :key="index" class="fix-padding-left" link :content="issue" @click="handleGo(index)" />
    </template>
    <div class="feedback" @click="handleClick">
      <x-svg-icon class="feedback-icon" name="edit-icon" />
      {{ $t('profile.help.feedback') }}
    </div>
  </div>
</template>

<script>
// import HeaderCustom from '@/components/header-show/header-custom.vue'
import LineText from '@/components/line-text/line-text.vue'
import ParamsCatchMixin from '@/mixin/params-catch.mixin.js'
export default {
  components: {
    // HeaderCustom,
    LineText
  },
  mixins: [ParamsCatchMixin],
  data () {
    return {
      issues: [
        this.$t('profile.help.tryoutDefinesysCloud'),
        this.$t('profile.help.inviteColleague'),
        this.$t('profile.help.createApplication'),
        this.$t('profile.help.increaseUses'),
        this.$t('profile.help.cannotReceiveVerificationCode'),
        this.$t('profile.help.retrieveData'),
        this.$t('profile.help.exportData'),
        this.$t('profile.help.applyForBilling'),
        this.$t('profile.help.howAcceptNotice'),
        this.$t('profile.help.howBindEmail'),
        this.$t('profile.help.howBindWeChatNotice')
      ],
      issuesMap: [
        'http://k8s.definesys.com:31005/support/mobile/q1/',
        'http://k8s.definesys.com:31005/support/mobile/q2/',
        'http://k8s.definesys.com:31005/support/mobile/q3/',
        'http://k8s.definesys.com:31005/support/mobile/q4/',
        'http://k8s.definesys.com:31005/support/mobile/q5/',
        'http://k8s.definesys.com:31005/support/mobile/q6/',
        'http://k8s.definesys.com:31005/support/mobile/q7/',
        'http://k8s.definesys.com:31005/support/mobile/q8/',
        'http://k8s.definesys.com:31005/support/mobile/question-duanxin/',
        'http://k8s.definesys.com:31005/support/mobile/question-mail/',
        'http://k8s.definesys.com:31005/support/mobile/question-weixin/'
      ]
    }
  },
  methods: {
    handleBack() {
      this.$router.push({
        name: 'personal-center'
      })
    },
    handleGo(index) {
      window.open(this.issuesMap[index])
    },
    handleClick() {
      window.open(`${window.location.origin}/xdap-h5/blank/public-form?shareId=73502931421106176&tenantId=58644709379145729`)
    }
  }
}
</script>

<style lang="scss" scoped>
.help-feedback {
  width: 100%;
  height: 100%;
  // padding-top: 3.14rem;
  background: $--app-body-bgColor;
  position: relative;
  .common-issue {
    padding: 1.143rem;
  }
  .feedback {
    position: absolute;
    width: 100%;
    height: 3.143rem;
    // bottom: 3.143rem;
    bottom: 0;
    background: $--app-light-color;
    display: flex;
    justify-content: center;
    align-items: center;
    .feedback-icon {
      height: 1.714rem;
      width: 1.714rem;
      padding-right: .286rem;
    }
  }
}
</style>
